export default class User {
    analytics:string = "";
    // progress:number = 0; // depricated. Use currentStory instead
    score:number = 0;
    stat:number = 0;
    positive:number = 0;
    negative:number = 0;
    currentChapter:number = 0;
    currentStory:number = 0;
    highscore:number = 0;
    firstName:string = "";
    lastName:string = ""
}



// WEBPACK FOOTER //
// ./src/objects/User.ts